import React from "react";
import "./styles.scss";

const PaginationDot = ({ activeIndex, pagination, containerClass }) => {
  return (
    <div className={`pagination-dots ${containerClass}`}>
      {pagination.map((_, index) => (
        <span
          key={index}
          className={index === activeIndex ? "dot active" : "dot"}
        ></span>
      ))}
    </div>
  );
};

export default PaginationDot;
